import {
  Component,
  AfterViewInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import * as $ from 'jquery';

declare let $: any;
@Component({
  selector: 'app-dropdown-select-control',
  templateUrl: './dropdown-select-control.component.html',
  styleUrls: ['./dropdown-select-control.component.css']
})
export class DropdownSelectControlComponent implements AfterViewInit {
  @Input() source: string[];
  @Input() elementId: string;
  @Input() classes: string;
  @Input() placeholder: string;
  @Input() searchTerm = '';
  @Input() suppressSearch = false;
  @Output() valueSelected: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngAfterViewInit() {
    const that = this;
    $('#' + that.elementId)
      .autocomplete({
        source: that.source,
        change: function(event, ui) {
          const retValue = ui.item ? ui.item.value : this.value;
          that.emitOutput(retValue);
          return true;
        },
        search: function(event, ui) {
          if (!that.suppressSearch) {
            const retValue = ui.item ? ui.item.value : this.value;
            that.emitOutput(retValue);
            return true;
          }
        },
        select: function(event, ui) {
          const retValue = ui.item ? ui.item.value : '';
          that.emitOutput(retValue);
          return true;
        },
        minLength: 0
      })
      .bind('focus', function() {
        if (
          !$(this)
            .val()
            .trim()
        ) {
          $(this).keydown();
        }
      });
  }

  emitOutput(value) {
    this.valueSelected.emit({ value: value, elementId: this.elementId });
  }
}
